webpackJsonp([79],{

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1367);


/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _de = __webpack_require__(848);

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('de', _de2.default);

/***/ })

},[1366]);


// WEBPACK FOOTER //
// app/datetime.de-679c105afb36f051c959.js